export default {
    stateFactory: function (StateClass) {
        return new StateClass();
    }
};
